import script from "./OrderMixins.vue?vue&type=script&lang=js"
export * from "./OrderMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__